import { FormikProvider, Formik, useFormik, Form } from "formik";
import React, {
  useEffect,
  useState,
  useRef,
  ReactNode,
  useContext,
} from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import LabelRequired from "../../component/LabelRequired";
import TextField from "../../component/TextField";
import DatePickerCustom from "../../component/date-picker/DatePickerCustom";
import PaymentInfoDialog from "./PaymentInfoDialog";
import { CODE, KEY } from "../../utils/Constant";
import { getIndexedDBItem } from "../../utils/IndexedDB";
import { KEY_DS_DANH_MUC_TIEP_DON, TERM_CLASS_IDS } from "../../utils/Constant";
import { IDanhSachDanhMuc } from "../../models/OctResponse";
import { calculateAge, formatDateTime } from "../../utils/FormatUtils";
import { set } from "react-datepicker/dist/date_utils";
import { getCategory } from "../../utils/AppFunction";
import { initialValuesParaclinical } from "../constants/MakeAnAppointment";
import { IParaclinical } from "../models/MakeAnAppointmentModels";
import { callApiHub, getServiceInfo } from "../services/services";
import { AppContext } from "../../appContext/AppContext";

type Props = {
  // show: boolean;
  // onHide: () => void;
  // data: any;
};

const ParaclinicalDetail = (props: Props) => {
  const intl = useIntl();
  const { setIsLoading } = useContext(AppContext);
  const [paymentInfoDialog, setPaymentInfoDialog] = React.useState(false);
  const [initialValues, setInitialValues] = React.useState<IParaclinical>(
    initialValuesParaclinical
  );
  const monthRef = useRef<HTMLInputElement>(null);
  const yearRef = useRef<HTMLInputElement>(null);
  const [gender, setGender] = useState<any>([]);
  const [danhSachDanhMuc, setDanhSachDanhMuc] = useState<IDanhSachDanhMuc>();
  const [provinces, setProvinces] = useState<any>([]);
  const [districts, setDistricts] = useState<any>([]);
  const [subDistricts, setSubDistricts] = useState<any>([]);
  const [patientValues, setPatientValues] = useState<any>(
    initialValues?.patient
  );
  const [personValues, setPersonValues] = useState<any>(
    initialValues?.patient?.person
  );
  const [visitValues, setVisitValues] = useState<any>(initialValues?.visit);
  const [patientAge, setPatientAge] = useState<any>(null);
  const PATIENT = "patient";
  const VISIT = "visit";
  const [serviceType, setServiceType] = useState<any[]>([]);
  const [serviceGroup, setServiceGroup] = useState<any[]>([]);
  const [services, setServices] = useState<any[]>([]);

  useEffect(() => {
    handleSetDefaultData();
    handleGetServiceType();
  }, []);

  useEffect(() => {
    formik.setFieldValue(PATIENT, {
      ...patientValues,
      person: {
        ...personValues,
      },
    });
    formik.setFieldValue(VISIT, {
      ...visitValues,
    });
  }, [patientValues, personValues, visitValues]);

  useEffect(() => {
    let age = calculateAge(
      personValues?.dobDay,
      personValues?.dobMonth,
      personValues?.dobYear
    );
    setPatientAge(age);
  }, [personValues?.dobDay, personValues?.dobMonth, personValues?.dobYear]);

  const handleGetServiceType = async () => {
    try {
      const { data } = await getServiceInfo();
      setServiceType(data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const validationSchema = Yup.object({
    // dichVuKham: Yup.object().nullable().required("Trường này là bắt buộc"),
    // fullName: Yup.string().required("Trường này là bắt buộc"),
    // date: Yup.string().nullable().required("Trường này là bắt buộc"),
  });

  const handleSetDefaultData = async () => {
    try {
      let res: IDanhSachDanhMuc = await getIndexedDBItem(
        KEY_DS_DANH_MUC_TIEP_DON
      );
      setDanhSachDanhMuc(res || []);
      setGender(res?.listGioiTinh || []);
      setProvinces(res?.provinces || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (values: IParaclinical) => {
    setIsLoading(true);

    const convertOrdersDto = visitValues?.ordersDto?.map((item: any) => {
      return {
        "termId": item?.id,
        "fulfillDeptCode": item?.code,
        "fulfillDeptName": item?.name,
        "objectTypeId": visitValues?.visitObjectType?.id,
        "objectTypeCode": visitValues?.visitObjectType?.code,
        "objectTypeName": visitValues?.visitObjectType?.name,
        "samplingDeptCode": item?.attributes?.deptSamplingDeptCode,
        "samplingDeptName": item?.attributes?.deptSamplingDeptName

      };
    });

    const submitData = {
      ...values,
      patient: {
        ...values?.patient,
        appointmentDate: values?.patient?.person?.appointmentDate,
        gender: values?.patient?.person?.gender,
      },
      ordersAndDiagnosis: {
        ordersDto: convertOrdersDto,
      },
    };
    try {
      const res = await callApiHub(submitData);
      if (res?.data?.code === CODE.SUCCESS) {
        toast.success(intl.formatMessage({ id: "TOAST.CREATE.SUCCESS" }));
        handleClearForm();
      } else {
        toast.error(`${res?.data?.message}`);
      }
    } catch (err) {
      toast.error(intl.formatMessage({ id: "GENERAL.ERROR" }));
    } finally {
      setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  const handleClearForm = () => {
    setPatientValues(null);
    setPersonValues(null);
    setVisitValues(null);
    setPatientAge(null);
  };

  const handleChangeInputDate = (name: string, value: any) => {
    const MAX_LENGHT_DAY = 2;
    const MAX_LENGHT_MONTH = 2;
    switch (name) {
      case "dobDay": {
        value?.length === MAX_LENGHT_DAY && monthRef.current?.focus();
        break;
      }
      case "dobMonth": {
        value?.length === MAX_LENGHT_MONTH && yearRef.current?.focus();
        break;
      }
      default:
        break;
    }
    handleChangePersonInfo(name, value);
  };

  const handleChangePersonInfo = (name: string, value: any) => {
    switch (name) {
      case "idNumber":
      case "phoneNumber":
        setPersonValues({
          ...personValues,
          [name]: value,
        });
        setPatientValues({
          ...patientValues,
          [name]: value,
        });
        break;
      case "fullName":
        setPersonValues({
          ...personValues,
          [name]: value,
        });
        setPatientValues({
          ...patientValues,
          [name]: value,
          personName: value,
        });
        break;
      case "ccountry":
        setPersonValues({
          ...personValues,
          [name]: value,
          country: value?.code,
        });
        break;
      case "dobDay":
      case "dobMonth":
      case "dobYear":
        setPersonValues({
          ...personValues,
          [name]: Number(value),
        });
        break;
      default:
        setPersonValues({
          ...personValues,
          [name]: value,
        });
        break;
    }
  };
  
  const handleChangeVisit = (name: string, value: any) => {
    switch (name) {
      case "visitType":
        setVisitValues({
          ...visitValues,
          [name]: value,
          visitTypeId: value?.id || "",
          visitTypeName: value?.name || "",
          visitTypeCode: value?.code || "",
        });
        break;
      case "visitObjectType":
        setVisitValues({
          ...visitValues,
          [name]: value,
          visitObjectTypeId: value?.id || "",
          visitObjectTypeName: value?.name || "",
          visitObjectTypeCode: value?.code || "",
        });
        break;
      case "serviceType":
        setServiceGroup(value?.terms);
        setVisitValues({
          ...visitValues,
          [name]: value,
          serviceGroup: null,
          service: null,
        });
        break;
      case "serviceGroup":
        setServices(value?.subs);
        setVisitValues({
          ...visitValues,
          [name]: value,
          service: null,
        });
        break;
      default:
        setVisitValues({
          ...visitValues,
          [name]: value,
        });
        break;
    }
  };

  const handleChangePatient = (name: string, value: any) => {
    switch (name) {
      case "occupation":
        setPatientValues({
          ...patientValues,
          [name]: value,
          occupationId: value?.id,
          occupationName: value?.name,
          occupationCode: value?.code,
        });
        break;
      case "ethnicity":
        setPatientValues({
          ...patientValues,
          [name]: value,
          ethnicityId: value?.id,
          ethnicityName: value?.name,
          ethnicityCode: value?.code,
        });
        break;
      case "province":
        let district =
          danhSachDanhMuc?.districts?.filter(
            (item: any) => item?.provinceId === value?.id
          ) || [];
        setDistricts(district);
        setPatientValues({
          ...patientValues,
          [name]: value,
          provinceId: value?.id,
          provinceCode: value?.code,
          provinceName: value?.name,
          district: null,
          subDistricts: null,
        });
        break;
      case "district":
        let subDistricts =
          danhSachDanhMuc?.subDistricts?.filter(
            (item: any) => item?.districtId === value?.id
          ) || [];
        setSubDistricts(subDistricts);
        setPatientValues({
          ...patientValues,
          [name]: value,
          districtId: value?.id,
          districtCode: value?.code,
          districtName: value?.name,
          subDistricts: null,
        });
        break;
      case "subDistricts":
        setPatientValues({
          ...patientValues,
          [name]: value,
          communeId: value?.id,
          communeCode: value?.code,
          communeName: value?.name,
        });
        break;
      default:
        setPatientValues({
          ...patientValues,
          [name]: value,
        });
        break;
    }
  };

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <div className="spaces p-0 mt-5 bg-white">
          <div className="spaces h-calc-vh-110">
            <div className=" spaces bg-white width-100 ">
              <h4 className="text-title fw-bold fs-5 ml-10 spaces mb-5">
                Thông tin đặt lịch
              </h4>

              <div className="bg-white spaces mb-6 pb-15 fl-1 ml-10 mr-10">
                <Row>
                  <Col lg={3} className="mb-3">
                    <LabelRequired isRequired label="Loại hình dịch vụ" />
                    <AutocompleteV2
                      options={serviceType}
                      isSearchDefauilt={true}
                      name={"serviceType"}
                      onChange={(options: any) => {
                        handleChangeVisit("serviceType", options);
                      }}
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                      value={visitValues?.serviceType || null}
                      // errors={formik?.errors?.service}
                      // touched={formik?.touched?.service}
                    />
                  </Col>

                  <Col lg={3} className="mb-3">
                    <LabelRequired isRequired label="Nhóm dịch vụ" />
                    <AutocompleteV2
                      options={serviceGroup}
                      isSearchDefauilt={true}
                      value={visitValues?.serviceGroup || null}
                      name="serviceGroup"
                      onChange={(options: any) => {
                        handleChangeVisit("serviceGroup", options);
                      }}
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                      isClearable={false}
                      dependencies={[visitValues?.serviceType]}
                    />
                  </Col>

                  <Col lg={6} className="mb-3">
                    <LabelRequired isRequired label="Dịch vụ" />
                    <AutocompleteV2
                      options={services || []}
                      value={visitValues?.ordersDto || null}
                      name="ordersDto"
                      onChange={(options: any) => {
                        handleChangeVisit("ordersDto", options);
                      }}
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                      isClearable={false}
                      isMulti={true}
                      closeMenuOnSelect={false}
                      dependencies={[visitValues?.serviceGroup]}
                      isSearchDefauilt={true}
                      getOptionValue={(option) => option.id}
                      getOptionLabel={(option) => option.name}
                    />
                  </Col>

                  <Col lg={3} className="mb-3">
                    <LabelRequired className="min-w-90px" label="ĐK khám" />
                    <AutocompleteV2
                      isSearchDefauilt={true}
                      options={danhSachDanhMuc?.listDKKham || []}
                      value={visitValues?.visitType || null}
                      name="visitType"
                      onChange={(selectedOption) =>
                        handleChangeVisit("visitType", selectedOption)
                      }
                      // touched={visitTouched?.visitType}
                      // errors={visitErrors?.visitType}
                      className="autocomplete-custom-tiep-nhan radius spaces width-100 h-29"
                      // isDisabled={
                      //   isVisitStopped ||
                      //   thongTinBenhNhan?.isExamined ||
                      //   thongTinBenhNhan?.isMedicalExamSvcPaid
                      // }
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired label="Ngày khám" />
                    <DatePickerCustom
                      className=" min-w-130px"
                      name="appointmentDate"
                      labelClassName="ps-2 min-w-90px"
                      setDateValue={(date) => {
                        handleChangePersonInfo("appointmentDate", date);
                      }}
                      value={personValues?.appointmentDate}
                      mode="date-time"
                    />
                  </Col>

                  <Col lg={6} className="mb-3">
                    <LabelRequired isRequired label="Lý do khám" />
                    <TextField
                      name={"visitReasonName"}
                      type={"text"}
                      onChange={(e: any) =>
                        handleChangeVisit("visitReasonName", e.target.value)
                      }
                      value={visitValues?.visitReasonName || ""}
                    />
                  </Col>
                </Row>
              </div>

              <h4 className="text-title fw-bold fs-5 ml-10 spaces mb-5">
                Thông tin bệnh nhân
              </h4>

              <div className="bg-white spaces mb-6 pb-15 fl-1 ml-10 mr-10">
                <Row>
                  <Col lg={3} className="mb-3">
                    <LabelRequired className="min-w-90px" label="Đối tượng" />
                    <AutocompleteV2
                      options={danhSachDanhMuc?.listDoiTuong || []}
                      value={visitValues?.visitObjectType || null}
                      name="visitObjectType"
                      onChange={(selectedOption) => {
                        handleChangeVisit("visitObjectType", selectedOption);
                      }}
                      // touched={visitTouched?.visitObjectType}
                      // errors={visitErrors?.visitObjectType}
                      isClearable={false}
                      className="autocomplete-custom-tiep-nhan radius spaces h-29"
                      // isDisabled={isVisitStopped}
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired isRequired label="Họ và tên" />
                    <TextField
                      name={"fullName"}
                      type={"text"}
                      onChange={(e: any) => {
                        handleChangePersonInfo(
                          e.target.name,
                          e.target.value.toUpperCase()
                        );
                      }}
                      value={personValues?.fullName || ""}
                      // touched={formik?.touched?.fullName}
                      // errors={formik?.errors?.fullName}
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired label="Giới tính" />
                    <AutocompleteV2
                      options={gender}
                      isSearchDefauilt={true}
                      name={"gender"}
                      value={personValues?.gender}
                      onChange={(options: any) => {
                        handleChangePersonInfo("gender", options);
                        handleChangePatient("gender", options.name);
                        handleChangePatient("genderCode", options.code);
                      }}
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                      isClearable={false}
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired
                      label="Quốc tịch"
                      className="ps-2 min-w-90px"
                    />
                    <AutocompleteV2
                      options={danhSachDanhMuc?.listQuocTich || []}
                      name="ccountry"
                      value={personValues?.ccountry}
                      valueField="code"
                      onChange={(selectedOption) => {
                        handleChangePersonInfo("ccountry", selectedOption);
                      }}
                      className="autocomplete-custom-tiep-nhan radius spaces width-100 h-29"
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired
                      label="Dân tộc"
                      className="ps-2 min-w-90px"
                    />
                    <AutocompleteV2
                      options={danhSachDanhMuc?.listDanToc || []}
                      value={patientValues?.ethnicity}
                      name="ethnicity"
                      onChange={(selectedOption) =>
                        handleChangePatient("ethnicity", selectedOption)
                      }
                      className="autocomplete-custom-tiep-nhan radius spaces width-100 h-29"
                    />
                  </Col>

                  <Col lg={3} className="mb-3">
                    <TextField
                      className=" min-w-130px"
                      label="Địa chỉ"
                      name="address"
                      value={patientValues?.address || ""}
                      labelClassName="min-w-90px"
                      onChange={(e: any) =>
                        handleChangePatient(e.target.name, e.target.value)
                      }
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired label="Tỉnh/ Thành phố" />
                    <AutocompleteV2
                      options={provinces}
                      getOptionLabel={(option: any) => `${option?.name}`}
                      value={patientValues?.province}
                      isSearchDefauilt={true}
                      name={"province"}
                      onChange={(options: any) =>
                        handleChangePatient("province", options)
                      }
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                      // errors={errors?.province}
                      // touched={touched?.province}
                    />
                  </Col>

                  <Col lg={3} className="mb-3">
                    <LabelRequired label="Quận/ Huyện" />
                    <AutocompleteV2
                      options={districts}
                      getOptionLabel={(option: any) => `${option?.name}`}
                      value={patientValues?.district}
                      isSearchDefauilt={true}
                      name={"district"}
                      onChange={(options: any) =>
                        handleChangePatient("district", options)
                      }
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                      dependencies={[patientValues?.province]}
                      // errors={errors?.district}
                      // touched={touched?.district}
                    />
                  </Col>

                  <Col lg={3} className="mb-3">
                    <LabelRequired label="Xã/ Phường" />
                    <AutocompleteV2
                      options={subDistricts}
                      getOptionLabel={(option: any) => `${option?.name}`}
                      value={patientValues?.subDistrictCode}
                      isSearchDefauilt={true}
                      name={"subDistricts"}
                      onChange={(options: any) =>
                        handleChangePatient("subDistricts", options)
                      }
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                      dependencies={[patientValues?.district]}
                      // errors={errors?.ward}
                      // touched={touched?.ward}
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired
                      className="ps-2 min-w-90px"
                      label="Nghề nghiệp"
                    />
                    <AutocompleteV2
                      // ref={occupationRef}
                      options={danhSachDanhMuc?.listNgheNghiep || []}
                      value={patientValues?.occupation}
                      name="occupation"
                      valueField="id"
                      onChange={(selectedOption) => {
                        handleChangePatient("occupation", selectedOption);
                      }}
                      // touched={patientTouched?.occupation}
                      // errors={patientErrors?.occupation}
                      className="autocomplete-custom-tiep-nhan radius spaces width-100 h-29"
                      // isDisabled={isVisitStopped}
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <LabelRequired
                      label="Ngày sinh"
                      isRequired
                      className="ps-2 min-w-90px"
                    />
                    <div className="spaces ms-0 d-flex min-w-130px">
                      <div className="spaces width-20">
                        <TextField
                          name="dobDay"
                          type="text"
                          maxLength="2"
                          className="text-center"
                          value={personValues?.dobDay || ""}
                          onChange={(e: any) =>
                            handleChangeInputDate(e.target.name, e.target.value)
                          }
                          // touched={personTouched?.dobDay}
                          // errors={personErrors?.dobDay}
                          // disabled={isVisitStopped}
                        />
                      </div>
                      <div className="spaces width-20">
                        <TextField
                          ref={monthRef}
                          name="dobMonth"
                          type="text"
                          maxLength="2"
                          className="text-center"
                          value={personValues?.dobMonth || ""}
                          onChange={(e: any) =>
                            handleChangeInputDate(e.target.name, e.target.value)
                          }
                          // touched={personTouched?.dobMonth}
                          // errors={personErrors?.dobMonth}
                          // disabled={isVisitStopped}
                        />
                      </div>
                      <div className="spaces width-25">
                        <TextField
                          ref={yearRef}
                          name="dobYear"
                          type="text"
                          maxLength="4"
                          className="text-center"
                          value={personValues?.dobYear || ""}
                          onChange={(e: any) =>
                            handleChangePersonInfo(
                              e.target.name,
                              e.target.value
                            )
                          }
                          // touched={personTouched?.dobYear}
                          // errors={personErrors?.dobYear}
                          // disabled={isVisitStopped}
                        />
                      </div>
                      <div className="spaces width-5 d-flex flex-center fw-bold">
                        -
                      </div>
                      <div className="spaces width-35">
                        <TextField
                          name="dobYear"
                          type="text"
                          maxLength="4"
                          className="text-center"
                          disabled
                          value={patientAge ?? ""}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={3} className="mb-3">
                    <TextField
                      className="min-w-130px no-spinners w-100"
                      label="Căn cước"
                      name="idNumber"
                      labelClassName="ps-2 min-w-90px"
                      value={personValues?.idNumber || ""}
                      onChange={(e: any) =>
                        handleChangePersonInfo(
                          e.target.name,
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                  </Col>
                  <Col lg={3} className="mb-3">
                    <TextField
                      label="Điện thoại"
                      name="phoneNumber"
                      type="number"
                      labelClassName="ps-2 min-w-90px"
                      value={personValues?.phoneNumber || ""}
                      onChange={(e: any) =>
                        handleChangePersonInfo(e.target.name, e.target.value)
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          <div className="spaces w-100 d-flex justify-content-end bg-white mt-2 gap-6 py-8 z-index-2">
            <Button
              className="btn-fill mx-3 spaces min-w-90px btn btn-primary"
              type="submit"
            >
              <i className="bi bi-floppy"></i> Lưu
            </Button>
            <Button
              variant="btn-fill spaces mx-3 mr-10  min-w-90px btn btn-secondary"
              onClick={handleClearForm}
            >
              <i className="bi bi-x-lg"></i> Huỷ
            </Button>
          </div>
        </div>
      </Form>
    </FormikProvider>
    // {
    //   paymentInfoDialog && (
    //     <PaymentInfoDialog
    //       handleClose={(isBackHomePage?: boolean) => {
    //         setPaymentInfoDialog(false);
    //         isBackHomePage && onHide();
    //       }}
    //     />
    //   )
    // }
  );
};

export default ParaclinicalDetail;
